import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Section, Container, MarkdownContent } from "../../components/Section"
import styled from "styled-components";

const Grid = styled.div`
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    margin:0 -5px;
    .markdown{
        text-align:center;        
        p{
            text-align:center;
        }
    }
    @media(min-width:576px){    
        margin:0 -10px;
        .markdown{
            text-align:left;            
            p{
                text-align:left;            
            }
        }
    }
    @media(min-width:1200px){
        margin:0 -20px;
    }
    @media(min-width:1600px){
        margin:0 -30px;
    }
`
const LeftGrid = styled.div`
    position: relative;
    width: 100%;
    padding:0 5px;
    @media(min-width:576px){
        padding:0 10px;
        flex: 0 0 55%;
        max-width: 55%;
        padding:0 10px;
    }
    @media(min-width:1200px){
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
        padding:0 20px;
    }
    @media(min-width:1600px){
        padding:0 30px;
    }
`
const RightGrid = styled.div`
    position: relative;
    width: 100%;
    padding:0 5px;
    text-align:center;        
    @media(min-width:576px){
        flex: 0 0 45%;
        max-width: 45%;
        padding:0 10px;
        text-align:left;            
    }

    @media(min-width:1200px){
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
        padding:0 20px;
    }
    @media(min-width:1600px){       
        padding:0 30px;
    }
`
const Figure = styled.div`
    border-radius:10px;
    overflow:hidden;
    margin-bottom:15px;
    .gatsby-image-wrapper{
        display:inline-block;
    }
`

const DurableSection = () => {
	return(
        <Section ept="60px" epb="60px" xpt="40px" xpb="40px" pt="30px" pb="30px" bgColor="#fff">
        <Container>
            <Grid>
                <LeftGrid>
                    <MarkdownContent className="markdown">
                        <h2>Durable Steel Structures – Built to Last</h2>
                        <p>Engineered metal buildings are a smart investment for homeowners, business owners, and hobbyists of all shapes and sizes. Whether you're building a carport, garage, workshop, agricultural barn, or commercial space, metal buildings are designed to withstand the elements while offering endless customization. They’re quicker to install than traditional structures, require less maintenance, and can be tailored to fit just about any purpose.</p>
                    </MarkdownContent>
                </LeftGrid>
                <RightGrid>
                    <Figure>
                        <StaticImage src="../../images/durable-structures.jpg" alt="Durable Structures - Built to Last" />
                    </Figure>
                </RightGrid>
            </Grid>
        </Container>
      </Section>
	)
}
export default DurableSection
